import React, { Component } from 'react'
import _ from 'lodash'

import { updateModuleData } from 'helpers/specHelpers'
import ListSpec from 'containers/Project/ListSpec/index'

class VoltageRegulatorSpec extends Component {
  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props

    const voltageRegulatorData = moduleData['voltage_regulator']
    if(!voltageRegulatorData) return null

    const newModuleData = updateModuleData(_.cloneDeep(voltageRegulatorData),
      (dataArr) => dataArr.map(data => {
        if (data.railType === 'NVVDD') return data

        // Delete edpPeak, edpContinuous and outputVoltage fields from non NVVDD configs
        const {
          edpPeak,
          edpContinuous,
          outputVoltage,
          ...newData
        } = data

        return newData
      })
    )

    return (
      <ListSpec
        moduleName='voltage_regulator'
        moduleData={ newModuleData }
        isModifiedPage={ isModifiedPage }
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
      />
    )
  }
}

export default VoltageRegulatorSpec
